import React, { useRef } from 'react';
import StatusBar from '../components/common/StatusBar';
import ProductGrid from '../components/retail/ProductGrid';
import Cart from '../components/common/Cart';
import VirtualKeypad from '../components/common/VirtualKeypad';

const RetailLayout = ({ 
  // États
  commandes,
  currentCommande,
  selectedLineIndex,
  currentCommandeIndex,
  
  // Fonctions
  addProductToCurrentCommande,
  saveCurrentCommande,
  loadCommande,
  setSelectedLineIndex,
  updateItemQuantity,
  removeItemFromCommande,
  clearCurrentCommande,
  createNewCommande,
  switchToCommande,
  saveSale,
  handlePaymentComplete
}) => {
  const clearCartRef = useRef();

  return (
    <div className="h-[calc(100vh-0px)] flex flex-col bg-gray-100" dir="ltr">
      {/* Barre de statut */}
      <StatusBar />
      
      {/* Contenu principal */}
      <div className="flex-1 flex gap-4 p-4 overflow-hidden">
        {/* Colonne gauche - Produits */}
        <div className="flex-1 min-h-0">
          <ProductGrid 
            onProductClick={addProductToCurrentCommande}
            commandes={commandes}
            currentCommandeIndex={currentCommandeIndex}
            createNewCommande={createNewCommande}
            switchToCommande={switchToCommande}
          />
        </div>
        
        {/* Colonne droite - Panier et Clavier */}
        <div className="w-96 flex flex-col gap-4 min-h-0">
          {/* Panier - Prend 60% de l'espace disponible */}
          <div className="flex-[3] min-h-0">
            <Cart 
              layoutType="retail" 
              onClearCart={clearCartRef}
              currentCommande={currentCommande}
              selectedLineIndex={selectedLineIndex}
              onLineSelect={setSelectedLineIndex}
              onUpdateQuantity={updateItemQuantity}
              onRemoveItem={removeItemFromCommande}
              onClearCommande={clearCurrentCommande}
              onSaveSale={saveSale}
              onPaymentComplete={handlePaymentComplete}
            />
          </div>
          
          {/* Clavier virtuel - Prend 40% de l'espace disponible */}
          <div className="flex-[2] min-h-0">
            <VirtualKeypad 
              selectedLineIndex={selectedLineIndex}
              currentCommande={currentCommande}
              clearCurrentCommande={clearCurrentCommande}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetailLayout; 